import React from "react";

import Dashboard from "./dashboard";

const LinkedInRotation = () => {
  return (
    <div className="h-full flex flex-col bg-gray-50 overflow-auto">
      <Dashboard />
    </div>
  );
};

export default LinkedInRotation;
